module.exports = __webpack_public_path__ + "static/img/order_icon3.2c2ee845.svg";